// extracted by mini-css-extract-plugin
export default {"title":"UserReviews_title__Uj8Q1","titleCount":"UserReviews_titleCount__nFTOR"};